import Grid from '@material-ui/core/Grid';
import { Controller } from 'react-hook-form';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function UserInputFields({
  childIinError,
  setChildIinError,
  parentStatusError,
  setParentStatusError,
  control
}) {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12} md={12} style={{ marginBottom: '20px' }}>
        <Controller
          name="childIin"
          control={control}
          defaultValue=""
          onChange={([event]) => {
            if (childIinError) setChildIinError('');
            return event.target.value;
          }}
          as={
            <TextField
              fullWidth
              label={t('attachChild_fillIin')}
              error={!!childIinError}
              helperText={childIinError}
            />
          }
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <Controller
          name="parentStatus"
          control={control}
          defaultValue=""
          onChange={([event]) => {
            if (parentStatusError) setParentStatusError('');
            return event.target.value;
          }}
          as={
            <TextField
              select
              fullWidth
              label={t('attachChild_chooseParentStatus')}
              error={!!parentStatusError}
              helperText={parentStatusError}
            >
              <MenuItem value="MOTHER">{t('attachChild_parentStatus_MOTHER')}</MenuItem>
              <MenuItem value="FATHER">{t('attachChild_parentStatus_FATHER')}</MenuItem>
            </TextField>
          }
        />
      </Grid>
    </>
  );
}
